"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElevateYourRentalExperience() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="escape-to-montego-bay" className="relative min-h-screen flex flex-col lg:flex-row bg-background text-foreground overflow-hidden">
      <div className="w-full lg:w-[60%] flex flex-col justify-center px-6 py-16 md:px-12 lg:px-20 xl:px-28 z-10">
        <div ref={textRef} className={`max-w-3xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-sans font-bold text-5xl md:text-6xl lg:text-7xl xl:text-8xl leading-[1.1] tracking-tighter mb-6">
            <span className="block text-foreground">Paradise Palms</span>
            <span className="block text-primary mt-2">Luxury Montego Bay Villa</span>
          </h1>
          
          <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl mb-12 leading-relaxed">Experience the ultimate Jamaican getaway at 4 Wendy Close. Our luxury 4-bedroom villa sleeps 9 guests, offering airport transfers and 24-hour service starting at $120 per night.&nbsp;</p>
        </div>
      </div>

      <div className="w-full lg:w-[40%] h-[50vh] lg:h-auto p-6 lg:p-6 lg:pl-0 flex items-stretch">
        <div className="w-full h-full relative overflow-hidden bg-muted rounded-[2.5rem] shadow-2xl">
          <img src="https://sacred-kid.10web.cloud/wp-content/uploads/2026/03/image1.jpeg.png" alt="Luxury Jamaican villa interior at Paradise Palms" className="absolute inset-0 w-full h-full object-cover object-center" loading="eager" />
          <div className="absolute inset-0 bg-primary/5 lg:hidden pointer-events-none" />
        </div>
      </div>
    </section>;
}